import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { putClientPolicyApplicationStepRequest } from '@client/model';

type UseEnsureDownloadPolicyIllustrationStepProps = {
  policyApplication: ClientPolicyApplication | null | undefined;
  clientPolicyApplicationId: string | undefined;
  steps: PolicyApplicationStep[] | undefined;
}

export function useEnsureDownloadPolicyIllustrationStep({
  policyApplication,
  clientPolicyApplicationId,
  steps,
}: UseEnsureDownloadPolicyIllustrationStepProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      policyApplication &&
      clientPolicyApplicationId &&
      steps &&
      !steps.some(step => step.stepType === 'download-policy-illustration')
    ) {
      dispatch(
        putClientPolicyApplicationStepRequest({
          clientPolicyApplicationId,
          stepType: 'download-policy-illustration',
          status: 'skipped',
        }),
      );
    }
  }, [policyApplication, clientPolicyApplicationId, steps, dispatch]);
}